export default defineNuxtPlugin(nuxtApp => {
  const isE2e = useRuntimeConfig().public.e2e;
  nuxtApp.vueApp.directive('hubble', {
    mounted(el: HTMLElement, binding: { value: string }) {
      if (process.env.NODE_ENV === 'test' || isE2e) {
        el.setAttribute('data-hubble', binding.value);
      }
    },
  });
});
